import { ChangeDetectionStrategy, Component, ElementRef, Input, inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { TelenetIconLibrary } from "./telenet-icon-library.service";

@Component({
   // eslint-disable-next-line @angular-eslint/component-selector
   selector: "telenet-icon",
   template: `
      <ng-content></ng-content>
   `,
   styles: [
      ":host {display: inline-block;}",
      ":host::ng-deep svg{width: 100%; height: 100%;}"
   ],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class TelenetIconComponent {
   private element = inject(ElementRef);
   private telenetIconsRegistry = inject(TelenetIconLibrary);
   private document = inject(DOCUMENT, { optional: true });

   private svgIcon: SVGElement;

   @Input()
   set name(iconName: string) {
      if (this.svgIcon) {
         this.element.nativeElement.removeChild(this.svgIcon);
      }

      const svgData = this.telenetIconsRegistry.getIcon(iconName);

      this.svgIcon = this.svgElementFromString(svgData);
      this.element.nativeElement.appendChild(this.svgIcon);
   }

   private svgElementFromString(svgContent: string): SVGElement {
      const div = this.document.createElement("DIV");

      div.className = "telenet-icon";
      div.innerHTML = svgContent;

      return (
         div.querySelector("svg") ||
         this.document.createElementNS("http://www.w3.org/2000/svg", "path")
      );
   }
}
